import React from 'react'
import { Document } from '@/payload-types'
import { GridBlock } from '@/components'

interface DocumentListProps {
  items: Document[]
}

function DocumentList({ items }: Readonly<DocumentListProps>) {
  return (
    <GridBlock
      blockType="grid"
      items={items.map((document) => ({
        relationTo: 'documents' as const,
        value: document,
      }))}
    />
  )
}

export { DocumentList }
